import React, {useState} from 'react';
import {Button, Form, message, Select, Modal, Input, Card} from "antd";
import {CloseOutlined, PlusOutlined, SaveOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {addDriver} from "../../../slices/driverSlice";
import {useGetDriverQuery, useNewDriverMutation} from "../../../slices/rootApiSlices/driverApiSlice";
import SearchCompany from "../../../components/SearchCompany";
import SearchVehicleWithID from "../../../components/SearchVehicleWithID";


const AddDriverModal = () => {

    const [form] = Form.useForm();
    const {Option} = Select;
    const {user} = useSelector(state => state.auth);
    const [driverHandle, {isLoading}] = useNewDriverMutation();
    const {refetch} = useGetDriverQuery(user?.token);

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [company_id, setCompanyID] = useState("");
    const [vehicle_id, setVehicleID] = useState("");
    const [isActive, setIsActive] = useState(false);

    const handleOk = async () => {
        const newVehicle = {
            name,
            surname,
            company_id,
            vehicle_id,
            isActive: form.getFieldValue("isActive")
        };
        try {
            const res = await driverHandle({token: user?.token, data: newVehicle}).unwrap();
            dispatch(addDriver(res?.data));
            setOpen(false);
            form.resetFields();
            refetch();
            message.success(res?.messageTR, 3);
        } catch (e) {
            message.error(e?.data?.messageTR || 'Bir hata oluştu.');

        }
    };

    const handleCancel = () => {
        setVehicleID("")
        setName("")
        setSurname("")
        setCompanyID("")
        setIsActive("")
        setOpen(false);
        message.warning('Araç eklemekten vazgeçildi', 3);
    };


    console.log(vehicle_id)

    return (
        <>
            <Button type="primary" onClick={() => setOpen(true)} style={{marginBottom: 10}} icon={<PlusOutlined/>}>
                Yeni Sürücü Ekle
            </Button>
            <Modal
                width={700}
                open={open}
                onOk={handleOk}
                cancelText="Vazgeç"
                closable={false}
                confirmLoading={isLoading}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" type="primary" danger icon={<CloseOutlined/>} onClick={handleCancel}>
                        Vazgeç
                    </Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={handleOk} icon={<SaveOutlined/>}>
                        Kaydet
                    </Button>
                ]}
            >
                <Card
                    title="Yeni Sürücü Ekle" size="small"
                    style={{borderColor: 'lightgray', boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.1)'}} type="inner"
                    bordered={true}
                >
                    <Form
                        form={form}
                        name="add-driver"
                        onFinish={handleOk}
                        onFinishFailed={handleCancel}
                        autoComplete="off"
                    >
                        <Form.Item label="İsim / Soyisim" style={{marginBottom: 0, marginTop: 15}}>
                            <Form.Item
                                style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'lütfen isim giriniz !',
                                    },
                                ]}
                                onChange={e => setName(e.target.value)}
                                value={name}
                            >
                                <Input placeholder="İsim"/>
                            </Form.Item>
                            <Form.Item
                                style={{display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px'}}
                                name="surname"
                                rules={[
                                    {
                                        required: true,
                                        message: 'lütfen soyisim giriniz !',
                                    },
                                ]}
                                onChange={e => setSurname(e.target.value)}
                                value={surname}
                            >
                                <Input placeholder="Soyisim"/>
                            </Form.Item>
                        </Form.Item>
                        <Form.Item label="Şirket" style={{marginBottom: 0}}>
                            <SearchCompany onChange={e => setCompanyID(e)}/>
                        </Form.Item>
                        <Form.Item label="Araç" style={{marginBottom: 0}}>
                            <SearchVehicleWithID onChange={e => setVehicleID(e)}/>
                        </Form.Item>
                        <Form.Item label="Durumu">
                            <Form.Item
                                name="isActive"
                                rules={[
                                    {
                                        required: true,
                                        message: 'lütfen durum giriniz !',
                                    },
                                ]}
                                value={isActive}
                            >
                                <Select
                                    onChange={(e) => setIsActive({...isActive})}
                                    placeholder="Durum seçiniz.."
                                    allowClear
                                >
                                    <Option value={true}>Aktif</Option>
                                    <Option value={false}>Pasif</Option>
                                </Select>
                            </Form.Item>
                        </Form.Item>
                    </Form>
                </Card>
            </Modal>
        </>
    );
};

export default AddDriverModal;
